import React from 'react'
import styled from 'styled-components'

const CustomerRefTextStyle = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 19em;
  text-align: center;

  span {
    p {
      margin: 0px;
    }
  }

.customer-title{
    color: ${({ theme }) => theme.colors.primary};
    margin-top:-1em;
}

@media all and (max-width: 725px) {
    max-width: 12em;
    padding-top: 3em;    
  }
`;

const CustomerRefText: React.FC = ({ children }) => {
  return (
    <CustomerRefTextStyle>
      {children}
    </CustomerRefTextStyle>
  )
}

export default CustomerRefText
